var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleMicrosoftword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.999,
    height: 34.089,
    viewBox: "0 0 35.999 34.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-microsoftword",
    "data-name": "Icon simple-microsoftword",
    d: "M36,5.6V30.42a.672.672,0,0,1-.223.519.762.762,0,0,1-.54.207H22.4V27.7H32.869V26.136H22.387V24.217H32.86V22.651H22.4V20.716h10.47V19.168H22.4v-1.94h10.47V15.663H22.4V13.745h10.47V12.18H22.4V10.222h10.47V8.731H22.4V4.842H35.238a.676.676,0,0,1,.537.223A.7.7,0,0,1,36,5.6ZM20.475.961V35.044L0,31.5V4.6L20.475.956Zm-3.09,10.062-2.563.158L13.178,21.359H13.14c-.081-.482-.382-2.167-.922-5.05l-.958-4.894-2.406.12L7.89,16.308c-.562,2.781-.876,4.4-.958,4.854H6.909L5.447,11.787l-2.2.117L5.6,23.729l2.451.157.922-4.6c.54-2.7.855-4.269.922-4.7h.068c.092.458.384,2.061.922,4.815l.922,4.737,2.655.157,2.97-13.275h-.052Z",
    transform: "translate(0 -0.956)",
    fill: "#26429f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleMicrosoftword);
export default __webpack_public_path__ + "static/media/simple-microsoftword.c32464de07482cc4e6e7e5a08450890a.svg";
export { ForwardRef as ReactComponent };